import * as commonConsts from '../../../../pages/common/CommonConsts';
import { isSelected } from '../../../../utils/Validation';

const getValidatorsAuthorityHolder = (props) => [
  {
    fieldName: 'primaryContact',
    fieldValue: props.primaryContact,
    isValid: (v) => {
      if (v === undefined) {
        return true;
      }

      if (v === '') {
        return false;
      } else {
        return true;
      }
    }
  },
  {
    fieldName: 'registeredOfficeAddress',
    fieldValue: {
      isAddressesValid: props.isAddressesValid,
      addressRegisteredOfficePlaceHolder: props.addressRegisteredOfficePlaceHolder
    },
    isValid: (v) => {
      let result = true;

      if (v.isAddressesValid === undefined) {
        return true;
      }

      return v.isAddressesValid.firstAddressValid || !!v.addressRegisteredOfficePlaceHolder;
    }
  },
  {
    fieldName: 'businessAddress',
    fieldValue: {
      otherAddresses: props.otherAddresses,
      isAddressesValid: props.isAddressesValid,
      sameAsRegisteredOffice: props.sameAsRegisteredOffice,
      addressBusinessPlaceholder: props.addressBusinessPlaceholder
    },
    isValid: (v) => {
      let result = true;

      if (v.isAddressesValid === undefined) {
        return true;
      }
      debugger;
      let hasAddress = false;

      if (v.otherAddresses !== undefined) {
        if (!!v.otherAddresses[0]) {
          if (!!v.otherAddresses[0].details) {
            hasAddress = true;
          }

          if (v.otherAddresses[0].enterManually === true) {
            hasAddress = true;
          }
        }
      }

      result = hasAddress || v.sameAsRegisteredOffice[0] || !!v.addressBusinessPlaceholder;

      return result;
    }
  },
  {
    fieldName: 'postalAddress',
    fieldValue: {
      isAddressesValid: props.isAddressesValid,
      sameAsRegisteredOffice: props.sameAsRegisteredOffice,
      addressPostalPlaceholder: props.addressPostalPlaceholder
    },
    isValid: (v) => {
      let result = true;

      if (v.isAddressesValid === undefined) {
        return result;
      }

      result =
        v.isAddressesValid.otherAddressesValidDetail[1] || v.sameAsRegisteredOffice[1] || !!v.addressPostalPlaceholder;

      return result;
    }
  }
];

const errorsDefaultValue = {
  registeredOfficeAddress: false,
  businessAddress: false,
  postalAddress: false
};

export { getValidatorsAuthorityHolder, errorsDefaultValue };
